import { render, staticRenderFns } from "./BankAccountInfo.vue?vue&type=template&id=768a84ed&scoped=true"
import script from "./BankAccountInfo.vue?vue&type=script&lang=js"
export * from "./BankAccountInfo.vue?vue&type=script&lang=js"
import style0 from "./BankAccountInfo.vue?vue&type=style&index=0&id=768a84ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768a84ed",
  null
  
)

export default component.exports